// Listas de opções regionais partilhadas entre o planner (PreferencesDialog)
// e o backoffice (AdminProfiles). Fonte única → os combos ficam iguais nos
// dois sítios, que editam o MESMO Perfil.

export const TIMEZONES = [
  { value: 'Africa/Luanda',   label: 'Luanda (Angola)' },
  { value: 'Africa/Maputo',   label: 'Maputo (Moçambique)' },
  { value: 'Africa/Bissau',   label: 'Bissau (Guiné-Bissau)' },
  { value: 'Africa/Praia',    label: 'Praia (Cabo Verde)' },
  { value: 'Africa/Sao_Tome', label: 'São Tomé' },
  { value: 'Europe/Lisbon',   label: 'Lisboa (Portugal)' },
  { value: 'Europe/Madrid',   label: 'Madrid (Espanha)' },
  { value: 'Europe/Paris',    label: 'Paris (França)' },
];

export const COUNTRIES = [
  { value: 'AO', label: 'Angola' },
  { value: 'MZ', label: 'Moçambique' },
  { value: 'GW', label: 'Guiné-Bissau' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'ST', label: 'São Tomé' },
  { value: 'PT', label: 'Portugal' },
  { value: 'ES', label: 'Espanha' },
  { value: 'FR', label: 'França' },
];

export const LANGUAGES = [
  { value: 'pt', label: '🇵🇹 Português' },
  { value: 'en', label: '🇬🇧 English' },
  { value: 'fr', label: '🇫🇷 Français' },
  { value: 'es', label: '🇪🇸 Español' },
];

// Dias da semana — convenção JS getDay(): 0=Domingo … 6=Sábado.
// Ordem de apresentação começa na Segunda (como se lê um calendário PT).
export const WEEKDAYS = [
  { value: 1, label: 'Seg' },
  { value: 2, label: 'Ter' },
  { value: 3, label: 'Qua' },
  { value: 4, label: 'Qui' },
  { value: 5, label: 'Sex' },
  { value: 6, label: 'Sáb' },
  { value: 0, label: 'Dom' },
];

// Tipos de Ordem de Trabalho — nomes canónicos partilhados.
export const ORDER_TYPES_META = [
  { key: 'assistance', label: 'Assistência técnica',   icon: '🔧' },
  { key: 'fuel',       label: 'Entrega de combustível', icon: '⛽' },
  { key: 'delivery',   label: 'Entrega de mercadoria',  icon: '📦' },
];
